function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 356 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 149,
    viewBox: "0 0 158 149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 153708",
    style: {
      fill: "none"
    },
    d: "M0 0h158v149H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 233"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 10",
    d: "M83.908 148.281c33.086 0 59.908-5.012 59.908-11.194s-26.822-11.194-59.908-11.194S24 130.9 24 137.087s26.822 11.194 59.908 11.194z",
    transform: "translate(-15.691 -6.965)",
    style: {
      fill: "rgba(245,245,247,.8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 11",
    d: "M133.412 97.659 112.271 71.64a5.308 5.308 0 0 0-4.059-1.966H62.758A5.307 5.307 0 0 0 58.7 71.64L37.56 97.659v13.593h95.853V97.659z",
    transform: "translate(-17.269 -.424)",
    style: {
      fillRule: "evenodd",
      fill: "#a4b8b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 12",
    d: "M57.365 31.67h60.028a3.534 3.534 0 0 1 3.535 3.535v82.482a3.534 3.534 0 0 1-3.535 3.535H57.365a3.535 3.535 0 0 1-3.535-3.535V35.2a3.535 3.535 0 0 1 3.535-3.535z",
    transform: "translate(-19.162 3.999)",
    style: {
      fill: "#f5f5f7",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 13",
    d: "M63.289 41.623h44.392a1.768 1.768 0 0 1 1.767 1.767v22.053a1.767 1.767 0 0 1-1.767 1.767H63.289a1.767 1.767 0 0 1-1.767-1.767V43.39a1.767 1.767 0 0 1 1.767-1.767zm.232 35.177h43.929a2 2 0 0 1 0 4H63.521a2 2 0 0 1 0-4zm0 10.394h43.929a2 2 0 0 1 0 4H63.521a2 2 0 0 1 0-4zm69.7 38.44a6.2 6.2 0 0 1-5.951 4.736H43.705a6.2 6.2 0 0 1-5.95-4.736 6.455 6.455 0 0 1-.2-1.582V94.4h23.259a4.724 4.724 0 0 1 4.639 4.789v.035a4.706 4.706 0 0 0 4.663 4.745h30.738a4.723 4.723 0 0 0 4.663-4.765v-.011a4.728 4.728 0 0 1 4.639-4.795h23.256v29.663a6.477 6.477 0 0 1-.2 1.581z",
    transform: "translate(-17.269 2.841)",
    style: {
      fill: "#d8e3e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14",
    d: "m147.921 29.418-6.035 2.342a.883.883 0 0 1-1.174-.6.877.877 0 0 1 .011-.489l1.712-5.485a13.868 13.868 0 0 1-3.631-9.2C138.8 7.159 147.744 0 158.773 0s19.968 7.159 19.968 15.991-8.941 15.991-19.969 15.991a23.585 23.585 0 0 1-10.851-2.564z",
    transform: "translate(-29.05 7.684)",
    style: {
      fill: "#d8e3e1",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 15",
    d: "M169.972 20.71a2.488 2.488 0 1 0-2.517-2.487 2.5 2.5 0 0 0 2.517 2.487z",
    transform: "translate(-32.384 5.853)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16",
    d: "M154.685 20.44h-5.035l2.561-4.353zm3.147-4.353h4.4v4.353h-4.4z",
    transform: "translate(-30.312 5.812)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultIcon);
export default __webpack_public_path__ + "static/media/no_result_icon.1e41eab39de2500e5ec81579756df4ad.svg";
export { ForwardRef as ReactComponent };